import { render, staticRenderFns } from "./ProductInShopRow.vue?vue&type=template&id=95b05092&scoped=true&"
import script from "./ProductInShopRow.vue?vue&type=script&lang=js&"
export * from "./ProductInShopRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductInShopRow.vue?vue&type=style&index=0&id=95b05092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b05092",
  null
  
)

export default component.exports